/**
 * @param {unknown} value
 * @returns {string}
 */
export function normalizeThreadEmail(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

/**
 * @param {unknown} value
 * @returns {boolean}
 */
export function isEmailLikeIdentifier(value) {
  return normalizeThreadEmail(value).includes("@");
}
